export default "__VITE_ASSET__B6D3RB_e__"